import React from 'react'
import { type TemplateLookup, type TemplateValue } from '../../../models/TemplateLibrary'
import { isSchedulingEmailTemplate, SCHEDULING_EMAIL_TYPE_LABEL, TEMPLATE_TYPES } from './TemplatesTab'

export interface TemplateTypeBadgeProps {
  templateValue: TemplateValue | TemplateLookup
}

const templateTypeNameByTemplate = (template: TemplateValue | TemplateLookup) => {
  const tab = TEMPLATE_TYPES.find(
    (tab) => tab.searchParams?.type === template.type && (!tab.searchParams?.typeId || tab.searchParams.typeId === template.typeId),
  )
  if (tab) {
    return tab.label
  }
  return isSchedulingEmailTemplate(template) ? SCHEDULING_EMAIL_TYPE_LABEL : 'Template'
}
export const TemplateTypeBadge: React.FC<TemplateTypeBadgeProps> = ({ templateValue }) => {
  return <p className='mb-0 paragraph-small template-badge zocks-bg-color-gray-200'>{templateTypeNameByTemplate(templateValue)}</p>
}
